import React from 'react';
import { IconProps } from './icons.models';

const ExportIcon: React.FC<IconProps> = ({
    width = 15,
    height = 15,
    fillColor = '#3EAE54',
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 0.75H14.25V6M14.25 9.55275V13.125C14.25 13.4234 14.1315 13.7095 13.9205 13.9205C13.7095 14.1315 13.4234 14.25 13.125 14.25H1.875C1.57663 14.25 1.29048 14.1315 1.0795 13.9205C0.868526 13.7095 0.75 13.4234 0.75 13.125V1.875C0.75 1.57663 0.868526 1.29048 1.0795 1.0795C1.29048 0.868526 1.57663 0.75 1.875 0.75H5.25M8.175 6.825L13.9125 1.0875" stroke={fillColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default ExportIcon;

